var map = {
	"./align-center.svg": 37,
	"./align-justify.svg": 38,
	"./align-left.svg": 39,
	"./align-right.svg": 40,
	"./arrow.svg": 41,
	"./audio.svg": 42,
	"./background.svg": 43,
	"./bold.svg": 44,
	"./button-refresh.svg": 45,
	"./clean.svg": 46,
	"./close.svg": 47,
	"./color.svg": 48,
	"./edit.svg": 49,
	"./error.svg": 50,
	"./formatbrush.svg": 51,
	"./hLink.svg": 52,
	"./image.svg": 53,
	"./import.svg": 54,
	"./indent.svg": 55,
	"./italic.svg": 56,
	"./list-bullet.svg": 57,
	"./list-ordered.svg": 58,
	"./loading_audio.svg": 59,
	"./pause_audio.svg": 60,
	"./pdf.svg": 61,
	"./play_audio.svg": 62,
	"./play_video.svg": 63,
	"./redo.svg": 64,
	"./splitline.svg": 65,
	"./subtitle.svg": 66,
	"./underline.svg": 67,
	"./undo.svg": 68,
	"./uploadf.svg": 69,
	"./video.svg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;